/* eslint-disable max-len */
export default {
  ACTIONS: {
    FINISH: 'Beenden',
    NEXT: 'Weiter'
  },
  ERRORS: {
    GREATER_THAN: 'Darf nicht größer sein als {max}.',
    INVALID_PROZIS_POINTS:
      'Ups, die ProzisPoints, die du mit dem Kurier teilen wolltest, sind nicht mehr verfügbar. Versuche es erneut.',
    LESS_THAN: 'Darf nicht kleiner sein als {min}.',
    MAX_CHARACTERS: 'Die Beschreibung darf maximal {max} Zeichen lang sein.',
    REQUIRED: 'Pflichtfeld.',
    VALIDATING_CODE: 'Der Code {code} kann nicht bestätigt werden.'
  },
  LABELS: {
    COMMENT: 'Kommentar',
    COURIER: 'Kurier',
    ERROR: 'Fehler',
    EXPERIENCE_EVALUATION: 'BEWERTE DEINE LIEFERERFAHRUNG',
    MORE_TO_SAY: 'IMPROVE OURSELVES',
    OTHER: 'Sonstiges',
    PROZIS_NOW: 'PROZIS NOW'
  },
  SENTENCES: {
    AMAZED:
      '😁 Wir freuen uns sehr zu hören, dass alles gut geklappt hat. Was hat dir am besten gefallen?',
    ANSWERED_SURVEY:
      'Wir haben bereits dein Feedback zur Lieferung der Bestellung {code}. \n\rWir freuen uns jedoch darauf, von deinen zukünftigen Erfahrungen zu hören. 👍',
    ENTITY: 'Was hälst du von {entity}?',
    POINTS: 'Du hast {points} ProzisPoints.',
    SATISFIED:
      '😁 Wir sind froh, dass alles gut geklappt hat, aber wie können wir uns verbessern?',
    SHARE_POINTS:
      'Möchtest du {entity} belohnen? Teile deine ProzisPoints mit ihm/ihr. 🙂',
    THANKS: '😀 Danke {name}.',
    UNHAPPY:
      '😔 Es tut uns leid zu hören, dass die Lieferung nicht wie erwartet verlaufen ist. Was ist schief gelaufen?'
  }
};
